import { useMap } from 'react-map-gl';
import { Cursor } from '../../map.types';

export const useCurrentCursor = (): Cursor => {
  const { map } = useMap();
  if (!map) {return Cursor.grab;}
  return map.getCanvas().style.cursor as Cursor;
};
